import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL

let servicesApi = {
    saveImage: (pageData) => axios.post('saveImage', pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    })
        .then(res => res.data),

    // seller categories APIs

    categories: {
        categoryTree: (pageData) => axios.post('categoryTree', pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data)
    },



    getProductDetail: (pageData) => axios.post('productGetByField', pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    }).then(res => res.data),

    getUploadUrl: (pageData) => axios.post('getUploadUrl', pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    })
        .then(res => res.data),

}

export default servicesApi;
